import React from 'react';
import { t } from '../../Language/Translator';

const EditStepper = ({ activeStep,setActiveStep }) => {


    const handleStepClick = (stepIndex) => {
        setActiveStep(stepIndex); // Update the active step when a step is clicked
    };


    const totalSteps = 4;

    return (
        <>
            <div className="top_section flex flex-col">
                <div className="mainSection w-full">
                    <div className="container-fluid">
                        <div className="wizard">
                            <ul className="nav flex flex-row nav-tabs justify-content-center m-auto border-0 position-relative" id="myTab" role="tablist">
                                <li className="line">
                                    <span style={{ width: `${(activeStep/(totalSteps-1)) * 100}%`, backgroundColor: '#19C489' }}></span>
                                </li>

                                <li className="nav-item flex-fill" role="presentation" data-bs-toggle="tooltip" data-bs-placement="top" title="Step 1">
                                    <a
                                        className={`nav-link ${activeStep >= 0 ? 'active' : ''} rounded-circle mx-auto d-flex align-items-center justify-content-center`}
                                        href="#step1"
                                        id="step1-tab"
                                        data-bs-toggle="tab"
                                        role="tab"
                                        aria-controls="step1"
                                        aria-selected={activeStep === 0}
                                        onClick={() => handleStepClick(0)}
                                    >
                                        <svg
                                            width="25"
                                            height="25"
                                            viewBox="0 0 20 21"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                d="M3.80599 0.0723399C3.53912 0.0685657 3.29089 0.208778 3.15635 0.439286C3.02182 0.669794 3.02182 0.954886 3.15635 1.18539C3.29089 1.4159 3.53912 1.55611 3.80599 1.55234H12.686C12.9529 1.55611 13.2011 1.4159 13.3356 1.18539C13.4702 0.954886 13.4702 0.669794 13.3356 0.439286C13.2011 0.208778 12.9529 0.0685657 12.686 0.0723399H3.80599ZM1.58599 3.03234C1.31912 3.02857 1.07089 3.16878 0.936352 3.39929C0.801815 3.62979 0.801815 3.91489 0.936352 4.14539C1.07089 4.3759 1.31912 4.51611 1.58599 4.51234V17.8323H6.02599V14.1323H9.20134C9.21984 14.0154 9.23876 13.8973 9.2765 13.7826C9.42598 13.3223 9.71485 12.9298 10.0974 12.6523H8.98599V11.1723H10.466V12.4399C10.48 12.4332 10.4917 12.4227 10.5065 12.4168C10.6263 11.2735 11.5965 10.3904 12.7554 10.3904C12.913 10.3904 13.0704 10.4085 13.2251 10.441C13.6543 9.96445 14.2614 9.69234 14.906 9.69234V4.51234C15.1729 4.51611 15.4211 4.3759 15.5556 4.14539C15.6902 3.91489 15.6902 3.62979 15.5556 3.39929C15.4211 3.16878 15.1729 3.02857 14.906 3.03234H1.58599ZM3.06599 5.25234H4.54599V6.73234H3.06599V5.25234ZM6.02599 5.25234H7.50599V6.73234H6.02599V5.25234ZM8.98599 5.25234H10.466V6.73234H8.98599V5.25234ZM11.946 5.25234H13.426V6.73234H11.946V5.25234ZM3.06599 8.21234H4.54599V9.69234H3.06599V8.21234ZM6.02599 8.21234H7.50599V9.69234H6.02599V8.21234ZM8.98599 8.21234H10.466V9.69234H8.98599V8.21234ZM11.946 8.21234H13.426V9.69234H11.946V8.21234ZM3.06599 11.1723H4.54599V12.6523H3.06599V11.1723ZM6.02599 11.1723H7.50599V12.6523H6.02599V11.1723ZM14.906 11.1723C14.6827 11.1724 14.4598 11.2673 14.3033 11.4571L13.7671 12.1075L12.9519 11.8964C12.4761 11.7736 12.0052 12.114 11.9749 12.6046L11.9243 13.4458L11.1395 13.7551C10.6822 13.9349 10.5024 14.4868 10.7666 14.9012L11.219 15.6123L10.7666 16.3234C10.5032 16.7378 10.6822 17.289 11.1395 17.4696L11.9243 17.7789L11.9749 18.62C12.0052 19.1107 12.4761 19.4511 12.9519 19.3282L13.7671 19.1172L14.3033 19.7676C14.6156 20.1465 15.1957 20.1465 15.5087 19.7676L16.0449 19.1172L16.8601 19.3282C17.3359 19.4511 17.8067 19.1107 17.8371 18.62L17.8877 17.7789L18.6725 17.4696C19.1298 17.2897 19.3095 16.7378 19.0454 16.3234L18.593 15.6123L19.0454 14.9012C19.3088 14.4868 19.1298 13.9342 18.6725 13.7537L17.8877 13.4444L17.8371 12.6046C17.8067 12.114 17.3359 11.7722 16.8601 11.895L16.0449 12.106L15.5087 11.4571C15.3522 11.2676 15.1293 11.1722 14.906 11.1723ZM3.06599 14.1323H4.54599V15.6123H3.06599V14.1323Z"
                                                fill={activeStep >= 2 ? 'green' : '#ABB7C2'}
                                            />
                                        </svg>
                                        <h5>{t("stepper.companyinformation")}</h5>
                                    </a>
                                </li>

                                <li className="nav-item flex-fill" role="presentation" data-bs-toggle="tooltip" data-bs-placement="top" title="Step 2">
                                    <a
                                        className={`nav-link ${activeStep >= 1 ? 'active' : ''} rounded-circle mx-auto d-flex align-items-center justify-content-center`}
                                        href="#step2"
                                        id="step2-tab"
                                        data-bs-toggle="tab"
                                        role="tab"
                                        aria-controls="step2"
                                        aria-selected={activeStep === 1}
                                        title="Step 2"
                                        onClick={() => handleStepClick(1)}
                                    >
                                        <svg
                                            width="25"
                                            height="25"
                                            viewBox="0 0 22 15"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                d="M2.95997 0.0273438C2.21962 0.0273438 1.61997 0.626994 1.61997 1.36734V10.7473C1.37835 10.7439 1.1536 10.8709 1.03179 11.0796C0.909977 11.2883 0.909977 11.5464 1.03179 11.7551C1.1536 11.9638 1.37835 12.0908 1.61997 12.0873H2.95997H3.664C3.82975 13.2166 4.80252 14.0973 5.97497 14.0973C7.14743 14.0973 8.12019 13.2166 8.28595 12.0873H13.01H14.384C14.5498 13.2166 15.5225 14.0973 16.695 14.0973C17.8674 14.0973 18.8402 13.2166 19.0059 12.0873H20.38C20.6216 12.0908 20.8463 11.9638 20.9682 11.7551C21.09 11.5464 21.09 11.2883 20.9682 11.0796C20.8463 10.8709 20.6216 10.7439 20.38 10.7473V7.39734H16.36V4.71734C16.36 4.3475 16.6601 4.04734 17.03 4.04734H18.9444L18.7181 3.51998C18.507 3.02753 18.0227 2.70734 17.4867 2.70734H13.01V1.36734C13.01 0.626994 12.4103 0.0273438 11.67 0.0273438H2.95997ZM6.97997 2.03734C8.82984 2.03734 10.33 3.53747 10.33 5.38734C10.33 7.23721 8.82984 8.73734 6.97997 8.73734C5.1301 8.73734 3.62997 7.23721 3.62997 5.38734C3.62997 3.53747 5.1301 2.03734 6.97997 2.03734ZM6.9695 2.69818C6.59999 2.70396 6.30491 3.00782 6.30997 3.37734V5.38734C6.30995 5.64113 6.45332 5.87315 6.6803 5.98668L8.0203 6.65668C8.23443 6.76379 8.48944 6.74851 8.68925 6.6166C8.88906 6.48469 9.0033 6.2562 8.98895 6.01721C8.97459 5.77822 8.8338 5.56504 8.61964 5.45801L7.64997 4.97383V3.37734C7.65245 3.19624 7.58151 3.02185 7.45332 2.8939C7.32513 2.76596 7.1506 2.69535 6.9695 2.69818ZM5.97497 10.7473C6.53795 10.7473 6.97997 11.1894 6.97997 11.7523C6.97997 12.3153 6.53795 12.7573 5.97497 12.7573C5.41199 12.7573 4.96997 12.3153 4.96997 11.7523C4.96997 11.1894 5.41199 10.7473 5.97497 10.7473ZM16.695 10.7473C17.258 10.7473 17.7 11.1894 17.7 11.7523C17.7 12.3153 17.258 12.7573 16.695 12.7573C16.132 12.7573 15.69 12.3153 15.69 11.7523C15.69 11.1894 16.132 10.7473 16.695 10.7473Z"
                                                fill={activeStep >= 1 ? 'green' : '#ABB7C2'}
                                            />
                                        </svg>
                                        <h5>{t("stepper.locations")}</h5>
                                    </a>
                                </li>

                                <li className="nav-item flex-fill" role="presentation" data-bs-toggle="tooltip"
                                    data-bs-placement="top" title="Step 3">
                                    <a className={`nav-link ${activeStep >= 2 ? 'active' : ''} rounded-circle mx-auto d-flex align-items-center justify-content-center`}
                                        href="#step3" id="step3-tab" data-bs-toggle="tab" role="tab"
                                        aria-controls="step3" aria-selected={activeStep === 2} title="Step 3"onClick={() => handleStepClick(2)}>
                                        <svg width="25" height="25" viewBox="0 0 20 21" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M8.28652 0.0381898C7.81773 0.0455177 7.44338 0.431009 7.4498 0.899811V1.74981V1.75313C6.88695 1.76311 6.34296 1.95578 5.90254 2.30762L3.40068 4.30811C2.72493 4.84871 2.28128 5.62612 2.15888 6.48292L1.62099 10.2498H1.4998C1.19326 10.2455 0.908132 10.4065 0.753597 10.6713C0.599061 10.9361 0.599061 11.2635 0.753597 11.5283C0.908132 11.7931 1.19326 11.9541 1.4998 11.9498H18.4998C18.8063 11.9541 19.0915 11.7931 19.246 11.5283C19.4005 11.2635 19.4005 10.9361 19.246 10.6713C19.0915 10.4065 18.8063 10.2455 18.4998 10.2498H18.3786L17.8407 6.48292C17.7183 5.62697 17.2747 4.84871 16.5989 4.30811L14.0987 2.30762C13.6583 1.95578 13.1127 1.76311 12.5498 1.75313V1.74981V0.899811C12.5529 0.670056 12.463 0.448812 12.3003 0.286492C12.1377 0.124172 11.9163 0.0346013 11.6865 0.0381898C11.2177 0.0455177 10.8434 0.431009 10.8498 0.899811V1.74981H9.1498V0.899811C9.15295 0.670056 9.06295 0.448812 8.90032 0.286492C8.73769 0.124172 8.51627 0.0346013 8.28652 0.0381898ZM8.2998 4.29981C8.769 4.29981 9.1498 4.68061 9.1498 5.14981C9.1498 5.61901 8.769 5.99981 8.2998 5.99981C7.8306 5.99981 7.4498 5.61901 7.4498 5.14981C7.4498 4.68061 7.8306 4.29981 8.2998 4.29981ZM11.6998 4.29981C12.169 4.29981 12.5498 4.68061 12.5498 5.14981C12.5498 5.61901 12.169 5.99981 11.6998 5.99981C11.2306 5.99981 10.8498 5.61901 10.8498 5.14981C10.8498 4.68061 11.2306 4.29981 11.6998 4.29981ZM8.2998 7.69981C8.769 7.69981 9.1498 8.08061 9.1498 8.54981C9.1498 9.01901 8.769 9.39981 8.2998 9.39981C7.8306 9.39981 7.4498 9.01901 7.4498 8.54981C7.4498 8.08061 7.8306 7.69981 8.2998 7.69981ZM11.6998 7.69981C12.169 7.69981 12.5498 8.08061 12.5498 8.54981C12.5498 9.01901 12.169 9.39981 11.6998 9.39981C11.2306 9.39981 10.8498 9.01901 10.8498 8.54981C10.8498 8.08061 11.2306 7.69981 11.6998 7.69981ZM10.0015 13.6498C1.89756 13.6498 0.649801 16.0397 0.649801 18.1953C0.649801 18.8855 0.828766 19.3633 1.02002 19.6778C1.21722 20.0008 1.59749 20.1574 1.96299 20.0613C2.87504 19.8233 4.84273 19.3082 5.75478 19.0702C6.05483 18.992 6.28424 18.756 6.36074 18.456L6.7459 16.9353C6.83175 16.5953 7.11292 16.3444 7.46142 16.3011C8.06322 16.2271 9.05205 16.1268 9.9998 16.1268C10.9476 16.1268 11.9355 16.2271 12.5382 16.3011C12.8867 16.3436 13.1679 16.5944 13.2537 16.9353L13.6389 18.456C13.7145 18.756 13.9481 18.992 14.2481 19.0702L18.035 20.0613C18.4013 20.1565 18.784 20 18.9812 19.6762C19.1716 19.3608 19.3498 18.8838 19.3498 18.1953C19.3498 16.0397 18.1054 13.6498 10.0015 13.6498Z"
                                                fill={activeStep >= 2 ? 'green' : '#ABB7C2'} />
                                        </svg>
                                        <h5>{t("stepper.contactinformation")}</h5>
                                    </a>
                                </li>

                                <li className="nav-item flex-fill" role="presentation" data-bs-toggle="tooltip"
                                    data-bs-placement="top" title="Step 4">
                                    <a className={`nav-link ${activeStep >= 3 ? 'active' : ''} rounded-circle mx-auto d-flex align-items-center justify-content-center`}
                                        href="#step4" id="step4-tab" data-bs-toggle="tab" role="tab"
                                        aria-controls="step4" aria-selected={activeStep === 3} title="Step 4" onClick={() => handleStepClick(3)}>
                                        <svg width="25" height="25" viewBox="0 0 21 20" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M2.23496 0.865322C1.284 0.865322 0.49496 1.65436 0.49496 2.60532V13.0453C0.490523 13.3591 0.655367 13.6509 0.92637 13.8091C1.19737 13.9673 1.53255 13.9673 1.80355 13.8091C2.07455 13.6509 2.2394 13.3591 2.23496 13.0453V2.60532H15.285C15.5987 2.60976 15.8906 2.44492 16.0487 2.17391C16.2069 1.90291 16.2069 1.56773 16.0487 1.29673C15.8906 1.02573 15.5987 0.860884 15.285 0.865322H2.23496ZM5.71496 4.34532C5.18339 4.34532 4.71226 4.59053 4.39297 4.96724L11.805 9.56532L19.1575 4.89587C18.8399 4.55918 18.3935 4.34532 17.895 4.34532H5.71496ZM19.635 6.33171L12.2654 11.0131C11.9836 11.1914 11.6247 11.1939 11.3411 11.0182L3.97496 6.44726V14.7853C3.97496 15.7467 4.75361 16.5253 5.71496 16.5253H11.9664C11.8689 16.2513 11.805 15.9616 11.805 15.6553C11.805 14  .2198 12.9795 13.0453 14.415 13.0453C14.415 11.6098 15.5895 10.4353 17.025 10.4353C18.4605 10.4353 19.635 11.6098 19.635 13.0453V6.33171ZM17.025 12.1753C16.5447 12.1753 16.155 12.5651 16.155 13.0453V14.7853H14.415C13.9347 14.7853 13.545 15.1751 13.545 15.6553C13.545 16.1356 13.9347 16.5253 14.415 16.5253H16.155V18.2653C16.155 18.7456 16.5447 19.1353 17.025 19.1353C17.5052 19.1353 17.895 18.7456 17.895 18.2653V16.5253H19.635C20.1152 16.5253 20.505 16.1356 20.505 15.6553C20.505 15.1751 20.1152 14.7853 19.635 14.7853H17.895V13.0453C17.895 12.5651 17.5052 12.1753 17.025 12.1753Z"
                                                fill={activeStep >= 3 ? 'green' : '#ABB7C2'} />
                                        </svg>
                                        <h5>{t("stepper.servicecontract")}</h5>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default EditStepper






// import React from 'react';


// const EditStepper = ({ activeStep, setActiveStep }) => {
//     const steps = [
//         { label: 'Company Information', icon: '🏢' },
//         { label: 'Locations', icon: '📍' },
//         { label: 'Contact Information', icon: '📞' },
//         { label: 'Service/Contract', icon: '📄' }
//     ];

//     return (
//         <div className="stepper">
//             <ul className="step-list">
//                 {steps.map((step, index) => (
//                     <li key={index} className={`step ${activeStep === index ? 'active' : ''}`}>
//                         <button onClick={() => setActiveStep(index)}>
//                             <span>{step.icon}</span> {/* Icon for each step */}
//                             <span>{step.label}</span> {/* Label for each step */}
//                         </button>
//                     </li>
//                 ))}
//             </ul>
//         </div>
//     );
// };

// export default EditStepper;



// import React, { useState } from "react";
// import EditCustomerStep1 from "./EditCustomerStep1";
// import EditCustomerStep2 from "./EditCustomerStep2";
// import EditCustomerStep3 from "./EditCustomerStep3";
// import EditCustomerStep4 from "./EditCustomerStep4";



// const EditStepper = () => {

//     const [activeStep, setActiveStep] = useState(0); // Track active step



//     const handleStepClick = (stepIndex) => {

//         setActiveStep(stepIndex); // Update active step on click

//     };



//     const totalSteps = 4;



//     return (

//         <>

//             <div className="top_section flex flex-col">

//                 <div className="mainSection w-full">

//                     <div className="container-fluid">

//                         <div className="wizard">

//                             <ul className="nav flex flex-row nav-tabs justify-content-center m-auto border-0 position-relative">

//                                 <li className="line">

//                                     <span

//                                         style={{

//                                             width: `${(activeStep / (totalSteps - 1)) * 100}%`,

//                                             backgroundColor: "#19C489",

//                                         }}

//                                     ></span>

//                                 </li>



//                                 {/* Step 1 */}

//                                 <li className="nav-item flex-fill">

//                                     <a

//                                         className={`nav-link ${activeStep === 0 ? "active" : ""}`}

//                                         onClick={() => handleStepClick(0)}

//                                     >

//                                         <h5>Company Information</h5>

//                                     </a>

//                                 </li>



//                                 {/* Step 2 */}

//                                 <li className="nav-item flex-fill">

//                                     <a

//                                         className={`nav-link ${activeStep === 1 ? "active" : ""}`}

//                                         onClick={() => handleStepClick(1)}

//                                     >

//                                         <h5>Locations</h5>

//                                     </a>

//                                 </li>



//                                 {/* Step 3 */}

//                                 <li className="nav-item flex-fill">

//                                     <a

//                                         className={`nav-link ${activeStep === 2 ? "active" : ""}`}

//                                         onClick={() => handleStepClick(2)}

//                                     >

//                                         <h5>Additional Details</h5>

//                                     </a>

//                                 </li>



//                                 {/* Step 4 */}

//                                 <li className="nav-item flex-fill">

//                                     <a

//                                         className={`nav-link ${activeStep === 3 ? "active" : ""}`}

//                                         onClick={() => handleStepClick(3)}

//                                     >

//                                         <h5>Summary</h5>

//                                     </a>

//                                 </li>

//                             </ul>

//                         </div>

//                     </div>

//                 </div>



//                 {/* Display Step Components */}

//                 <div className="step-content">

//                     {activeStep === 0 && <EditCustomerStep1 />}

//                     {activeStep === 1 && <EditCustomerStep2/>}

//                     {activeStep === 2 && <EditCustomerStep3 />}

//                     {activeStep === 3 && <EditCustomerStep4 />}

//                 </div>

//             </div>

//         </>

//     );

// };



// export default EditStepper;





